import React from 'react'
import { Collapse } from 'react-collapse';
import './Collapse.css'

const MyCollapse = (props) => {
  return <Collapse {...props}/>
}

export default MyCollapse
